import API from './api'
import '../scss/pages/search.scss'

class Search {
  constructor() {
    document.addEventListener('DOMContentLoaded', () => {
      this.nav = document.querySelector('#nav-menu')
      this.btnBack = this.nav.querySelector('.js-back')
      this.form = document.forms.search
      this.btnClear = this.form.querySelector('.js-clear')
      this.input = this.form.querySelector('.input')
      this.counter = this.form.querySelector('.js-counter')
      this.results = document.querySelector('#results')
      this.query = ''

      this.init()
    })
  }

  init() {
    this.btnBack.addEventListener('click', () => {
      window.history.back(-1)
    })

    this.form.addEventListener('submit', (e) => {
      e.preventDefault()
      this.search()
    })

    this.btnClear.addEventListener('click', () => {
      this.input.value = ''
      this.input.focus()
      this.results.innerHTML = ''
      this.counter.parentNode.classList.add('is-hidden')
      this.btnClear.parentNode.classList.add('is-hidden')
    })

    this.input.focus()
  }

  search() {
    if (this.input.value === this.query) return
    this.btnClear.parentNode.classList.remove('is-hidden')

    return API.search(this.input.value).then((body) => {
      this.results.innerHTML = body
      this.query = this.input.value

      const count = this.results.querySelector('input[name="count"]')
      this.counter.parentNode.classList.toggle(
        'is-hidden',
        !count || count.value == '0'
      )

      if (count != '0') {
        this.counter.innerHTML = count.value + ' rezultate'
      }
    })
  }
}

const search = new Search()
